import { render, staticRenderFns } from "./SupplierPortalRequestQuoteTab.vue?vue&type=template&id=7789f064"
import script from "./SupplierPortalRequestQuoteTab.vue?vue&type=script&lang=js"
export * from "./SupplierPortalRequestQuoteTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports